export const UUIDtoHash = (str) => {
    return str.split("-").map((p, i, a) => a[[3, 4, 2, 1, 0][i]]).join("")
}
export const hashToUUID = (str) => {
    return [[24, 32], [20, 24], [16, 20], [0, 4], [4, 16]].map(([start, end]) => str.slice(start, end)).join("-")
}